import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Button, Checkbox, Input, Modal, Select } from 'antd'
import IconUploader from './IconUploader'
import ConfirmButton from '@components/ConfirmButton'
import { companies } from '@services/api'

import * as styles from './styles.scss'

@inject((store: any) => {
    const { popupStore } = store
    return { popupStore }
})
@observer
export default class CompanyPopup extends Component<any, any> {
    closePopup = () => {
        this.props.popupStore.togglePopup(false)
    }

    setError = (errorName, errorMsg) => {
        this.props.popupStore.addErrors(errorName, errorMsg)
        return false
    }

    validateCompany = () => {
        const { name } = this.props.popupStore.info

        if (!name) {
            return this.setError('nameError', 'אנה הזן שם חברה')
        } else {
            this.setError('nameError', null)
        }

        return true
    }

    saveCompany = async () => {
        const { popupType, info } = this.props.popupStore

        try {
            if (popupType === 'addCompany') {
                await companies.addCompany(info)
            } else if (popupType === 'editCompany') {
                await companies.updateCompany(info)
            }
            this.props.popupUpdated()
            this.closePopup()
        } catch (e) {
            if (e.response.status === 400) {
                this.setError('serverErrors', e.response.data)
            } else {
                this.setError('serverErrors', [{ message: 'בעיה בחיבור לשרת' }])
            }
        }
    }

    deleteCompany = async id => {
        await companies
            .deleteCompany(id)
            .then(res => {
                if (res.status === 200) {
                    this.closePopup()
                    this.props.popupUpdated()
                }
            })
            .catch(e => {
                this.setError('serverErrors', e.response.data)
            })
    }

    setValue = (e, name) => {
        this.props.popupStore.editInfo(name, e)
    }

    render() {
        const { popupStore } = this.props
        const { name, long_name, hmo, ltc_rel_id, id, type } = popupStore.info
        const { nameError, serverErrors } = popupStore.errors
        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                {popupStore.popupType === 'editCompany' ? (
                    <ConfirmButton
                        confirmed={() => this.deleteCompany(id)}
                        confirmQuestion="למחוק חברה?"
                        buttonText="מחק חברה"
                    />
                ) : null}
                <div style={{ float: 'left', display: 'inline-block' }}>
                    <Button onClick={this.closePopup}>ביטול</Button>
                    <Button type="primary" onClick={this.saveCompany}>
                        {popupStore.popupType === 'addCompany' ? 'הוסף' : 'שמור'}
                    </Button>
                </div>
            </div>
        )

        return (
            <Modal
                title={popupStore.popupType === 'addCompany' ? 'הוספת חברה' : 'עריכת חברה'}
                visible={popupStore.popupType === 'addCompany' || popupStore.popupType === 'editCompany'}
                onCancel={this.closePopup}
                okText={popupStore.popupType === 'addCompany' ? 'הוסף' : 'שמור'}
                cancelText="ביטול"
                footer={footerButtons}
            >
                {serverErrors ? <span className={styles.server_error}>{serverErrors[0].message}</span> : ''}

                <Input
                    placeholder="שם חברה"
                    value={name}
                    autoComplete="off"
                    name="name"
                    onChange={e => this.setValue(e.target.value, 'name')}
                />
                {nameError ? <span className={styles.error}>{nameError}</span> : ''}
                <Input
                    placeholder="שם חברה רשמי"
                    value={long_name}
                    autoComplete="off"
                    name="long_name"
                    onChange={e => this.setValue(e.target.value, 'long_name')}
                />

                <Input
                    type="number"
                    placeholder="שיוך לחברה על פי מזהה"
                    value={ltc_rel_id}
                    autoComplete="off"
                    name="ltc_rel_id"
                    onChange={e => this.setValue(e.target.value, 'ltc_rel_id')}
                />

                <Select
                    placeholder="סוג החברה"
                    style={{ width: '100%' }}
                    value={type ? type : undefined}
                    onChange={e => this.setValue(e, 'type')}
                >
                    <Select.Option value="INSURANCE">חברת ביטוח</Select.Option>
                    <Select.Option value="HMO">קופת חולים</Select.Option>
                    <Select.Option value="GOV">חברה ממשלתית</Select.Option>
                </Select>

                <Checkbox checked={hmo} onChange={e => this.setValue(e.target.checked, 'hmo')}>
                    החברה היא קופת חולים
                </Checkbox>

                <IconUploader bucket={'companies'} related={id} />
            </Modal>
        )
    }
}
